import React, { useState } from 'react';
import { createHrEmployee, updateHrEmployee } from '../../services/api';
import { PAY_TYPES } from './tsFormat';

const EMPTY = {
  full_name: '', position: '', pay_type: 'hourly', rate: '', percent: '',
  phone: '', email: '', hire_date: '', status: 'active', user_id: '', notes: '',
};

const EmployeeFormModal = ({ employee, positions, jobPositions = [], accounts, onClose, onSaved }) => {
  const [form, setForm] = useState(() => (employee
    ? {
      ...EMPTY,
      ...employee,
      rate: employee.rate || '',
      percent: employee.percent || '',
      user_id: employee.user_id || '',
      hire_date: employee.hire_date || '',
    }
    : EMPTY));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const set = (key) => (e) => setForm(prev => ({ ...prev, [key]: e.target.value }));

  /* Выбор должности из справочника подставляет её ставку и тип оплаты —
     но только новому сотруднику и только в пустое поле: у работающего
     человека ставка своя, и затирать её выбором должности нельзя. */
  const setPosition = (e) => {
    const name = e.target.value;
    const known = jobPositions.find(p => p.name === name);
    setForm(prev => ({
      ...prev,
      position: name,
      ...(known && !employee && !prev.rate
        ? { pay_type: known.default_pay_type, rate: known.default_rate || '' }
        : {}),
    }));
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.full_name.trim()) {
      setError('Укажите ФИО');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const payload = {
        ...form,
        rate: Number(form.rate) || 0,
        percent: Number(form.percent) || 0,
        user_id: form.user_id ? Number(form.user_id) : null,
      };
      if (employee) await updateHrEmployee(employee.id, payload);
      else await createHrEmployee(payload);
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сохранить');
      setSaving(false);
    }
  };

  return (
    <div className="ui-modal" onClick={onClose}>
      <div className="ui-modal-box wide" onClick={(e) => e.stopPropagation()}>
        <div className="ui-modal-head">
          <h2>{employee ? 'Карточка сотрудника' : 'Новый сотрудник'}</h2>
          <button className="ui-icon-btn" onClick={onClose} aria-label="Закрыть">×</button>
        </div>

        <form className="ui-form" onSubmit={submit}>
          <div className="ui-grid">
            <div className="ui-field wide">
              <label>ФИО</label>
              <input value={form.full_name} onChange={set('full_name')} placeholder="Иванова Мария" />
            </div>
            <div className="ui-field">
              <label>Должность</label>
              <input
                list="hr-positions"
                value={form.position}
                onChange={setPosition}
                placeholder="Администратор"
              />
              <datalist id="hr-positions">
                {(jobPositions.length ? jobPositions.map(p => p.name) : positions || [])
                  .map(name => <option key={name} value={name} />)}
              </datalist>
            </div>
            <div className="ui-field">
              <label>Тип оплаты</label>
              <select value={form.pay_type} onChange={set('pay_type')}>
                {PAY_TYPES.map(p => <option key={p.value} value={p.value}>{p.label}</option>)}
                {form.pay_type === 'percent' && <option value="percent">Процент от выручки</option>}
              </select>
            </div>
            {form.pay_type === 'percent' ? (
              <div className="ui-field">
                <label>Процент</label>
                <input type="number" step="0.1" value={form.percent} onChange={set('percent')} placeholder="5" />
              </div>
            ) : (
              <div className="ui-field">
                <label>{(PAY_TYPES.find(p => p.value === form.pay_type) || PAY_TYPES[0]).rateLabel}</label>
                <input type="number" step="1" value={form.rate} onChange={set('rate')} placeholder="300" />
              </div>
            )}
            <div className="ui-field">
              <label>Статус</label>
              <select value={form.status} onChange={set('status')}>
                <option value="active">Работает</option>
                <option value="fired">Уволен</option>
              </select>
            </div>
            <div className="ui-field">
              <label>Телефон</label>
              <input value={form.phone || ''} onChange={set('phone')} placeholder="+7 900 000-00-00" />
            </div>
            <div className="ui-field">
              <label>Email</label>
              <input value={form.email || ''} onChange={set('email')} />
            </div>
            <div className="ui-field">
              <label>Дата приёма</label>
              <input type="date" value={(form.hire_date || '').slice(0, 10)} onChange={set('hire_date')} />
            </div>
            <div className="ui-field">
              <label>Учётка в системе</label>
              <select value={form.user_id || ''} onChange={set('user_id')}>
                <option value="">— не связана —</option>
                {(accounts || []).map(a => (
                  <option key={a.id} value={a.id}>{a.full_name} ({a.username})</option>
                ))}
              </select>
            </div>
            <div className="ui-field wide">
              <label>Заметки</label>
              <input value={form.notes || ''} onChange={set('notes')} placeholder="Например: работает по субботам" />
            </div>
          </div>

          {error && <div className="ui-inline-error">{error}</div>}

          <div className="ui-modal-actions">
            <button type="button" className="ui-btn-ghost" onClick={onClose}>Отмена</button>
            <button type="submit" className="ui-btn-primary" disabled={saving}>
              {saving ? 'Сохранение…' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeFormModal;
